import {
	Backdrop,
	Box,
	CircularProgress,
	Grid,
	Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import KPIDashboardModal from "./KPIDashboardModal";
import SynchronizationStatusModal from "./SynchronizationStatusModal";
import { useDispatch, useSelector } from "react-redux";
import CustomLoadingScreen from "../../../components/ui/CustomLoadingScreen";
import QuotaSubmissionStatusChart from "./QuotaSubmissionStatusChart";
import ConsumptionRatio from "./ConsumptionRatio";
import {
	getConsumptionByCountry,
	getGeoData,
	getOrderStatus,
	getQuotaSubmissionStatusData,
	getScenarioCriticalityList,
	getSynchronizationStatus,
	getUserCountries,
} from "../dashBoardSlice";
import SearchForm from "./SearchForm";

export default function AtaGlance() {
	const dispatch = useDispatch();
	const { dataLoaded, totalData } = useSelector((store) => store.dashboard);
	const drawerOpen = useSelector((store) => store.global.drawerOpen);

	useEffect(() => {
		dispatch(getQuotaSubmissionStatusData());
		dispatch(getConsumptionByCountry());
		// dispatch(getGeoData());
		dispatch(getSynchronizationStatus());
		dispatch(getOrderStatus());
		dispatch(getUserCountries());
		dispatch(getScenarioCriticalityList());
	}, []);

	if (dataLoaded < totalData) {
		return (
			<Box>
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}}
					open={dataLoaded < totalData}
				>
					<CircularProgress />
				</Backdrop>
			</Box>
		);
	}

	return (
		<Box sx={{ maxWidth: drawerOpen ? "70vw" : "100%" }}>
			<Grid
				container
				justifyContent={"flex-end"}
				columnGap={2}
				rowGap={2}
				marginTop={1}
			>
				<Grid item>
					<KPIDashboardModal />
				</Grid>
				<Grid item>
					<SynchronizationStatusModal />
				</Grid>
			</Grid>
			<Grid sx={{ mt: 2 }} container spacing={2}>
				<Grid sx={{ flex: 1 }} item>
					<QuotaSubmissionStatusChart />
				</Grid>
				<Grid sx={{ flex: 1 }} item>
					<ConsumptionRatio />
				</Grid>
			</Grid>

			<Grid item>
				<SearchForm />
			</Grid>
		</Box>
	);
}
